<template>
  <div class="col-xl-6 col-lg-6 col-md-6 border-bottom border-right border-left screen-height" style="padding-left: 0px !important; padding-right: 0px !important;">
    <div class="photos p-0">

      <div class="photobttns">
        <div class="row border-dark border-bottom">
          <div class="col-md-5">
            <span class="photoicon">
              <i class="fa-regular fa-image" style="color: #737373"></i>
<!--              <img src="@/assets/images/FotosIcon.svg" style="width:2.5rem">-->
              <span>
              {{selectedImages.length}}
            </span></span> Fotos
          </div>
          <div class="col-sm-7 pr-0 text-right btn-actions">
            <a @click="rotateMultiImages('-90')" class="rotbtn">
              <img src="@/assets/images/rotateLeft.svg"   alt="logo" style="width:1.6rem; cursor: pointer">
            </a>
            <a @click="rotateMultiImages('90')" class="rotbtn">
              <img src="@/assets/images/rotateRight.svg"   alt="logo" style="width:1.6rem; cursor: pointer">
            </a>
            <a @click="rotateMultiImages('180')" class="rotbtn">
              <img src="@/assets/images/rotate180.svg"   alt="logo" style="width:1.7rem; cursor: pointer">
            </a>
            <a  @click="deleteMultiPhotos()" class="mb-2">
              <img src="@/assets/images/delete1.svg"   alt="logo" style="width:1.8rem; cursor: pointer">
            </a>
          </div>
        </div>

      </div>
      <div class="col-md-12">
        <div class="form-row cpics">
          <div class="col col-md-3" v-for="photo in selectedImages" :key="photo.id">
            <img :src="photo.src" class="img-fluid" alt="selected Photo">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex'

export default {
  data () {
    return {}
  },
  computed: {
    ...mapState({
      photos: state => state.photo.photos,
      selectedImages: state => state.photo.detailsSelectedImages
    })
  },
  methods: {
    async rotateMultiImages (degree) {
      let payload = {id: this.$route.params.id, photos: this.selectedImages, rotateVal: degree}
      await this.$store.dispatch('rotateMultiPhotos', payload)
      await this.$store.dispatch('refreshPhotos', payload)
    },

    async deleteMultiPhotos () {
      let selectedPhotos = this.selectedImages
      if (confirm('Sicher das Sie die ausgewählten Fotos löschen wollen?')) {
        let payload = {id: this.$route.params.id, photos: selectedPhotos}
        let photos = this.photos.filter((photo) => {
          if (selectedPhotos.find(item => item.id == photo.id)) {
            return false
          }
          return photo
        })
        await this.$store.dispatch('deleteMultiPhotos', payload)
        this.$store.commit('setAllImages', photos)
        this.$store.commit('setDetailsSelectedImages', [])
      }
    }
  }
}
</script>
<style scoped>
.photobttns{
  position: relative !important;
}
.btn-actions a{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/photo/components/DetailsMultiPhotos.vue